module.exports = __webpack_public_path__ + "static/media/iconCommitIdling.9ec0e2ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconCommitIdling.svg
// module id = 945
// module chunks = 0